import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  // Accordion do projeto revisado: status na primeira linha, parecer na linha
  // inteira dos detalhes.
  reviewAccordion: {
    borderTopWidth: 4,
    borderTopStyle: 'solid',
    '&:before': {
      display: 'none',
    },
  },
  // Cores dos mesmos tokens usados no chip de status do projeto na listagem
  // (PrivacyByDesignTable/styles.js), para o alerta e o chip combinarem.
  reviewAccordionApproved: {
    borderTopColor: theme.palette.success.main,
  },
  reviewAccordionRiskAssumed: {
    borderTopColor: theme.palette.grapePurple,
  },
  reviewAccordionDisapproved: {
    borderTopColor: theme.palette.error.main,
  },
  reviewSummary: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    width: '100%',
  },
  reviewDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    paddingTop: theme.spacing(1),
  },
  // O parecer pode ser longo, então ganha rolagem própria em vez de esticar o
  // card. O fundo cinza destaca o texto do revisor, como o rodapé dos cards.
  reviewerOpinionBox: {
    maxHeight: theme.spacing(25),
    overflowY: 'auto',
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
  },
  reviewerOpinionText: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },
  reviewActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
  },
  approvedIcon: {
    color: theme.palette.success.main,
  },
  riskAssumedIcon: {
    color: theme.palette.grapePurple,
  },
  disapprovedIcon: {
    color: theme.palette.error.main,
  },
}))

export default styles
